import React, {forwardRef} from 'react';
import {
  SoopCheckbox,
  CheckboxProps as SoopCheckboxProps,
} from '@soop-ui/soop-ui';

interface CheckBoxProps extends SoopCheckboxProps {
  value?: boolean;
  style?: React.CSSProperties;
}

const CheckBox = forwardRef<HTMLInputElement, CheckBoxProps>(
  ({value = false, style = {}, ...restProps}, ref) => {
    return (
      <div style={style}>
        <SoopCheckbox ref={ref} checked={value} {...restProps} />
      </div>
    );
  },
);

CheckBox.displayName = 'CheckBox';

export default CheckBox;
